import { Component, OnInit, Input, ViewChild, AfterViewInit, ChangeDetectorRef, TemplateRef } from '@angular/core';
import { EpbtFaSmartviewsService } from '../../services/epbt-fa-smartviews.service';
import {
  IEpDropdownButtonItem, IEpDropdownButtonModel, EpDataViewModelService, IEpToolTipModel,
  EpDialogService
} from '@epicor/kinetic';
import {
  FieldAgentClient, SortParametersDirection, OrderDetailOrderType, Customer, SearchParamsRequest,
  PagingParameters, SortParameters, PortalSearchParametersSuperPortalSearchParameterType,
  PortalSearchParametersSuper, Mode, CustomerSearchParameters, Opportunity
} from 'ep-bt-field-agent-proxy';
import { ActivatedRoute, Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { Rights } from '../../core-objects/Rights';
import { PermissionLevel, LocalStorageSaveTypes, SearchPageNames } from 'ep-bt-controls';
import { EpbtFaCustomerService } from '../../services/epbt-fa-customer.service';
import { Location } from '@angular/common';
import { EpbtFaSmartTilesService } from '../../services/epbt-fa-smart-tiles.service';
import { EpbtFaOpportunityService } from '../../services/epbt-fa-opportunity.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { EpbtFaContactsService } from '../../services/epbt-fa-contacts.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-smartviews-details',
  templateUrl: './epbt-fa-smartviews-details.component.html',
  styleUrls: ['./epbt-fa-smartviews-details.component.scss']
})
export class EpbtFaSmartviewsDetailsComponent implements OnInit {

  selectedsmartViewsData: any;
  selectedSmartViewsDetails: any[] = [];
  selectedSmartViewsGridData: any[] = [];
  tabList: any[] = [];
  data: IEpDropdownButtonItem[] = [];
  result: any;
  invoiceId: number;
  webTrackUser: any;
  orderDetail: any;
  startIndex = 0;
  dropdown: IEpDropdownButtonModel;
  selectedname: any;
  notepadID: number;
  customer: any;

  configuration = {
    icon: false,
    image: false,
    template: false,
    itemTemplate: false,
    canClose: true,
    hidden: false
  };

  @ViewChild('tooltipTemplate', { static: false }) tooltipTemplate: TemplateRef<any>;
  epToolTip: IEpToolTipModel = {
    filter: '.smartview_Title'
  };

  constructor(public SmartviewsService: EpbtFaSmartviewsService, private client: FieldAgentClient,
    private router: Router, private faService: EpbtFieldAgentService, private customerService: EpbtFaCustomerService,
    private faSmartTilesService: EpbtFaSmartTilesService,
    private location: Location, private opportunityService: EpbtFaOpportunityService,
    public productService: EpbtFaProductService, private contactsService: EpbtFaContactsService,
    private epDialogService: EpDialogService) { }

  ngOnInit() {
    this.epToolTip.tooltipTemplate = this.tooltipTemplate;
    this.selectedsmartViewsData = this.SmartviewsService.selectSmartViewColumnsData;
    // && this.SmartviewsService.selectSmartViewColumnsData.length > 0 ? this.SmartviewsService.selectSmartViewColumnsData[0] : null;
    this.selectedSmartViewsDetails = this.SmartviewsService.selectedGridData;
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
    $('#BacktoSmartViewId').focus();
    this.tabDataLoad();
    const columnNamesList = this.SmartviewsService.keys(this.selectedsmartViewsData);
    try {
      // this.result = this.selectedsmartViewsData.find(x => x[this.SmartviewsService.selectedGridData.key1] == this.SmartviewsService.selectedGridData.value1);
      this.result = this.selectedsmartViewsData;
      const rows: any[] = [];
      // console.log(this.result, "result selected");
      // if (this.selectedsmartViewsData) {
      //   this.SmartviewsService.columns.forEach(columnName => {
      //     // var col = this.smartViewColumns.find(x => x.listColumnName.toUpperCase() == (this.selectedFolderData.smartViewID.toString() + "_" + data.toUpperCase()));
      //     if (columnName != null && !columnName.hidden) {
      //       rows.push({
      //         key: columnName.caption,
      //         // value: this.result[columnName.caption.charAt(0).toLocaleLowerCase() + columnName.caption.slice(1)]
      //         value: this.selectedsmartViewsData[columnName.caption]
      //       });
      //     }
      //   });
      // }


      if (this.selectedsmartViewsData) {
        let i = 0;
        columnNamesList.forEach(columnName => {
          const column = this.SmartviewsService.columns[i];
          if (column != null && !column.hidden) {
            rows.push({
              key: column.caption,
              value: this.selectedsmartViewsData[columnName],
              uniqueId: columnName
            });
          }
          i = i + 1;
        });
      }

      this.selectedSmartViewsGridData = rows;
      this.tabEnable();
      this.SmartviewsService.fromPage = SearchPageNames.SmartviewDetails;
    } catch (e) {

    }


  }

  tabDataLoad() {
    this.dropdown = {
      text: 'MORE OPTIONS',
      data: this.data,
      showCaretIcon: true,
      caretIcon: 'mdi mdi-menu-down',
      sysIcon: 'mdi mdi-cogs',
      onCanClosePopup: () => {
        return this.configuration.canClose;
      }
    };
  }


  keys(obj) {
    return Object.keys(obj);
  }

  tabEnable() {
    for (let i = 0; i < this.SmartviewsService.supportedLinkedColumnNames.length; i++) {
      this.SmartviewsService.supportedLinkedColumnNames[i].isVisible =
        this.selectedsmartViewsData[Object.keys(this.selectedsmartViewsData).find(key => key.toLocaleLowerCase() === this.SmartviewsService.supportedLinkedColumnNames[i].id.toLocaleLowerCase())] ? true : false;
      // this.selectedSmartViewsGridData.some(x => x.uniqueId.toUpperCase() == this.SmartviewsService.supportedLinkedColumnNames[i].id.toUpperCase());
    }
    this.tabList = this.SmartviewsService.supportedLinkedColumnNames;
    this.dropdownDataPrepare();
  }

  dropdownDataPrepare() {
    this.tabList.forEach(tabCaption => {
      if (tabCaption.isVisible == true) {
        this.data.push({
          caption: tabCaption.name
        });
      }
    });

    // console.log(this.data);
    // this.data.caption = this.tabList.map(x=>x.name);

  }

  onSelectionChange(selectedValue: any) {
    // console.log(this.result,"result smartview");
    this.selectedname = selectedValue.caption;
    this.SmartviewsService.isSmartviews = true;
    if (this.selectedname == 'Customer') {
      //const customerId = this.result.CustomerID;
      let customerId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "CustomerID".toLocaleLowerCase())];
      if (customerId) {
        this.customerService.getCustomerbyCustomerId(customerId, (customer: any) => {
          this.customer = customer;
          this.customerService.selectedCustomer = customer;
          localStorage.setItem(LocalStorageSaveTypes.Index, '0');

          // localStorage.setItem(LocalStorageSaveTypes.Status, args.statusText + "/" + args.statusIcon + "/" + args.statusColor);
          this.router.navigate(['/home/customer/details', customerId]);

        });
      }
      else
        this.openDialog(null, "Customer is not available");
    } else if (this.selectedname == 'Customer contact') {
      // const contactID = this.result.CustomerContactID;
      let contactID = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "CustomerContactID".toLocaleLowerCase())];
      if (contactID) {
        //const customerId = this.result.CustomerID;
        let customerId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "CustomerID".toLocaleLowerCase())];
        const webTrackUser = this.webTrackUser;
        webTrackUser.customer = new Customer();
        webTrackUser.customer.customerID = -1;

        const searchCustomerParams = new CustomerSearchParameters();
        searchCustomerParams.customerId = webTrackUser.customer.customerID;
        searchCustomerParams.webTrackCustomersOnly = false;
        searchCustomerParams.paging = null;
        searchCustomerParams.sorting = null;


        this.client.findContacts(searchCustomerParams).subscribe(res => {

          this.customerService.getCustomerbyCustomerId(customerId, (customer: any) => {
            this.customer = customer;
            localStorage.setItem(LocalStorageSaveTypes.Type, LocalStorageSaveTypes.Edit);
            localStorage.setItem(LocalStorageSaveTypes.CustomerName, this.customer.name);
            this.contactsService.customerContact = null;
            this.router.navigate(['/home/contact/addcontact', contactID]);
          });


        });
      }
      else
        this.openDialog(null, "Customer Contact is not available");
    } else if (this.selectedname == 'Invoice') {
      // this.invoiceId = this.result.InvoiceID;
      this.invoiceId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "InvoiceID".toLocaleLowerCase())];
      if (this.invoiceId) {
        this.client.getInvoice(this.webTrackUser, this.invoiceId).subscribe(res => {
          // console.log(res);
          EpDataViewModelService.current.add('selectedItem', [res]);
          this.router.navigate(['/home/documents/details']);
        });
      }
      else
        this.openDialog(null, "Invoice is not available");
    } else if (this.selectedname == 'Customer notepad') {
      // this.notepadID = this.result.customernotepadid;
      this.notepadID = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "customernotepadid".toLocaleLowerCase())];
      if (this.notepadID) {
        this.client.getCustomerNotepadItem(this.notepadID).subscribe(res => {
          const notepadDetails = res && res.lines.length > 0 ? res.lines[0] : null;
          if (notepadDetails) {
            this.isNotepadRestricted((result: any) => {
              if (this.webTrackUser.isAdmin || !result) {
                const customerID = notepadDetails.customerID;
                const notepadId = notepadDetails.customerNotepadID;
                this.router.navigate(['/home/notepad/addnotepad', customerID, notepadId]);
              } else {
                // this.lblWarning.Text = "* You do not have permission to view selected document.";
                // this.lblWarning.Visible = true;
              }
            });
          }
        });
      }
      else
        this.openDialog(null, "Customer Notepad is not available");
    } else if (this.selectedname == 'Order/Quote/Template') {
      // const orderId = this.result.OrderID;
      let orderId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "OrderID".toLocaleLowerCase())];
      // Query the OrderType for the given OrderID and redirect appropriately.
      if (orderId) {
        this.client.getOrderDetail(orderId).subscribe(res => {
          //  console.log(res);
          this.orderDetail = res;
          switch (this.orderDetail.orderType) {
            case OrderDetailOrderType.Order: {
              const webTrackUser = this.webTrackUser;
              // webTrackUser.customer = new Customer();
              // webTrackUser.customer.customerId = -1;
              //  console.log(JSON.stringify(webTrackUser), "smartview details webtrack users")
              this.client.getOrder(webTrackUser, orderId).subscribe(res => {
                console.log(res, 'tempalte/order');
                EpDataViewModelService.current.add('selectedItem', [res]);
                this.router.navigate(['/home/documents/details']);

              });
              break;
            }
            case OrderDetailOrderType.Quote: {
              const webTrackUser = this.webTrackUser;
              // webTrackUser.customer = new Customer();
              // webTrackUser.customer.customerID = -1;
              this.client.getQuote(webTrackUser, orderId).subscribe(res => {
                EpDataViewModelService.current.add('selectedItem', [res]);
                this.router.navigate(['/home/documents/details']);
              });
              break;
            }
            case OrderDetailOrderType.TemplateOrder: {

              const webTrackUser = this.webTrackUser;
              // webTrackUser.customer = new Customer();
              // webTrackUser.customer.customerID = -1;
              this.client.getTemplateOrder(webTrackUser, orderId).subscribe(res => {
                EpDataViewModelService.current.add('selectedItem', [res]);
                this.router.navigate(['/home/documents/details']);
              });
              break;
            }
            case OrderDetailOrderType.CallOffOrder: {
              const webTrackUser = this.webTrackUser;
              // webTrackUser.customer = new Customer();
              // webTrackUser.customer.customerID = -1;

              const searchParamsRequest = new SearchParamsRequest();
              searchParamsRequest.user = this.webTrackUser;
              searchParamsRequest.user.customer.customerId = webTrackUser.customer.customerID;
              // Paging
              // searchParamsRequest.pagingParameters = new PagingParameters();
              // searchParamsRequest.pagingParameters.index = this.startIndex;
              // searchParamsRequest.pagingParameters.count = 50;
              searchParamsRequest.pagingParameters = null;

              // Sorting
              // searchParamsRequest.sortParameters = new SortParameters();
              // searchParamsRequest.sortParameters.sortColumn = "OrderNumber";
              // searchParamsRequest.sortParameters.direction = SortParametersDirection.Ascending;
              searchParamsRequest.sortParameters = null;
              // Search parameters
              searchParamsRequest.searchParameters = new PortalSearchParametersSuper();
              searchParamsRequest.searchParameters.portalSearchParameterType = PortalSearchParametersSuperPortalSearchParameterType.PortalSearchSingleParameters;
              searchParamsRequest.searchParameters.isEmpty = false;
              searchParamsRequest.searchParameters.propertyName = 'Customer';
              searchParamsRequest.searchParameters.searchValue = '';

              this.client.getCallOffOrderHeaders(searchParamsRequest).subscribe(res => {
                EpDataViewModelService.current.add('selectedItem', [res]);
                this.router.navigate(['/home/documents/details']);
              });
              break;
            }

          }
        });
      }
      else
        this.openDialog(null, "Order/Quote/Template is not available");
    } else if (this.selectedname == 'Opportunity') {
      //const opportunityId = this.result.OpportunityID;
      let opportunityId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "OpportunityID".toLocaleLowerCase())];
      if (opportunityId) {
        this.client.getOpportunity(opportunityId).subscribe(res => {
          if (res) {
            // EpDataViewModelService.current.add("selectedItem", [res]);
            // this.router.navigate(['/home/documents/details']);
            this.opportunityService.docOpportunity = new Opportunity();
            this.router.navigate(['/home/documents/addopportunity', res.customerID, res.opportunityID]);
          }
        });
      }
      else
        this.openDialog(null, "Opportunity is not available");

    } else if (this.selectedname == 'Credit note') {
      // const creditNoteId = this.result.CreditNoteID;
      let creditNoteId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "CreditNoteID".toLocaleLowerCase())];
      if (creditNoteId) {
        this.client.getCreditNote(this.webTrackUser, creditNoteId).subscribe(res => {
          if (res) {
            EpDataViewModelService.current.add('selectedItem', [res]);
            this.router.navigate(['/home/documents/details']);
          }
        });
      }
      else
        this.openDialog(null, "Credit Note is not available");

      // this.client.getCreditNote(this.webTrackUser, creditNoteId).subscribe(res => {
      //   EpDataViewModelService.current.add("selectedItem", [res]);
      //   this.router.navigate(['/home/documents/details']);
      // });
    } else if (this.selectedname == 'Product') {
      // const productId = this.result.ProductID;
      let productId = this.result[Object.keys(this.result).find(key => key.toLocaleLowerCase() === "ProductID".toLocaleLowerCase())];
      if (productId) {
        this.client.getProduct(productId).subscribe(res => {
          if (res) {
            this.productService.selectedProductItem = res;
            this.productService.selectedProductItem.dateTimeCreated = new Date();
            this.router.navigate(['/home/product/details', res.productId]);
          }
        });
      }
      else
        this.openDialog(null, "Product is not available");
    }
  }

  isNotepadRestricted(subscribe: (result: boolean) => void) {
    const result = this.selectedSmartViewsGridData.find(x => x.key == 'CustomerNotepadID');
    if (result) {
      const test = result.value;
      let notepadTypes;

      const permissions = this.webTrackUser.rights.find(x => x.name == Rights.NotepadCreditControl.name);
      const userHasCreditControlRead = permissions.permission.perRead == PermissionLevel.PleGranted || permissions.permission.perRead == PermissionLevel.PleInherited;

      this.client.getCustomerNotepadTypes(Mode.Edit, userHasCreditControlRead, this.webTrackUser.userId).subscribe(res => {
        console.log(res);
        notepadTypes = res;
        if (notepadTypes.length > 0) {
          // We need to get Notepad to get to Notepadtypeid ...

          // var r = ServiceLocator.Instance.BisTrack.CRMDataService.GetCustomerNotepadItem(notepadID);
          this.client.getCustomerNotepadItem(this.notepadID).subscribe(res => {
            const n = res.lines[0];
            if (n.notepadTypeID != null) {
              const notepadType = notepadTypes.find(nt => nt.notepadTypeID == n.notepadTypeID);
              subscribe(notepadType == null);
            } else {
              // It is Appointment type
              subscribe(false);
            }
          });
        } else {
          // no types ? no restrictions
          subscribe(false);
        }
      });
    } else {
      subscribe(false);
    }
  }

  backButtonClick() {
    this.SmartviewsService.isShowChildGrid = false;
    this.faSmartTilesService.setSmartViewHeader(this.SmartviewsService.selectedDashboardId); // set again
    // this.location.back();
  }

  private openDialog(title: any, message: any, description?: string, details?: string) {
    this.epDialogService.info({
      title: title ? title : "Info",
      message: message,
      description: description ? description : null,
      details: details ? details : null
    });
  }
}
